import { render, staticRenderFns } from "./EndpointList.vue?vue&type=template&id=540fc30a"
import script from "./EndpointList.vue?vue&type=script&lang=js"
export * from "./EndpointList.vue?vue&type=script&lang=js"
import style0 from "./EndpointList.vue?vue&type=style&index=0&id=540fc30a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports